module.exports = __webpack_public_path__ + "img/bookCover.28f679ab.jpg";